import {
  CompassCardComponent,
  CompassCardComponentProps,
} from 'react-scale/corp/views/DataCompassV2/types';
import { useUser } from 'react-scale/components/ui/UserContext';
import { StepItem } from 'react-scale/corp/views/qm/QMRuleDetailsPage';
import useGenericAutoOpsCard from './useGenericAutoOpsCard';

const GenericAutoOpsComponent: CompassCardComponent = ({ index }: CompassCardComponentProps) => {
  const user = useUser();
  const { step, setStep, hasError } = useGenericAutoOpsCard(index);
  return (
    <StepItem
      user={user}
      step={step}
      setStep={setStep}
      isCompassStep={true}
      forceTouched={hasError}
    ></StepItem>
  );
};

export default GenericAutoOpsComponent;
